import classes from './serviceAccountDetailsComponent.scss';
import Header from "../../../AccountPreferences/Presentational/Header";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
let CAN;
const ServiceAccountDetailsComponent = (props) => {
  let strings = getLocalizedStrings("ServiceAccountDetails");
  let details=props.accountData;

  let streetAdd=(props.accountData.streetAddress)? (props.accountData.streetAddress).toLowerCase() : null;
  let acctCity=(props.accountData.city) ? (props.accountData.city).toLowerCase() : null;
  let postBoxNumber = props.accountData.postBoxNumber && props.accountData.postBoxNumber!== '' ? 'PO Box '+ props.accountData.postBoxNumber : '';
  let supplement = (props.accountData.supplement)? (", "+props.accountData.supplement):null;

  
  
  CAN = details.contractAccountNumber;

  const serviceAccountDetailsJSX = <div className={classes.sceServiceAccInfoOuter}>
   {(details.houseNumber!=="" && details.streetAddress!=="") ? 
   <div className={classes.sceServiceAccInfo}>
   <div className={classes.serviceAccountDetails}><span className={classes.actInfo}> {postBoxNumber!==''?postBoxNumber+",":postBoxNumber} {details.houseNumber} {streetAdd}{supplement}, {acctCity && acctCity + ', '}{details.state} {details.zipcode}</span>&nbsp;<span className={classes.accountData}>{" - Acct.  "} {CAN}</span>
   </div>
   </div> 
   :
   <div className={classes.sceServiceAccInfo}>
      <div className={classes.serviceAccountDetails}><span className={classes.actInfo}>{postBoxNumber!==''?postBoxNumber+",":postBoxNumber} {supplement} {acctCity && acctCity + ', '}{details.state} {details.zipcode}</span>&nbsp;<span className={classes.accountData}>{" - Acct.  "} {CAN}</span>
  </div>
  </div>
   }
  </div>;

  return (
    <div>
      {serviceAccountDetailsJSX}
    </div>
  );
};

export default ServiceAccountDetailsComponent;
